import { render } from "./ProductGallerySimple.vue?vue&type=template&id=0f2d5e84&scoped=true"
import script from "./ProductGallerySimple.vue?vue&type=script&lang=js"
export * from "./ProductGallerySimple.vue?vue&type=script&lang=js"

import "./ProductGallerySimple.vue?vue&type=style&index=0&id=0f2d5e84&scoped=true&lang=scss"
import "./ProductGallerySimple.vue?vue&type=style&index=1&id=0f2d5e84&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f2d5e84"]])

export default __exports__